export default [
    {
    path: "/camaronera/mantenimiento/empleado",
    name: "camaronera-mantenimiento-empleado",
    component: () =>
        import("@/views/pages/profremar/mantenimientos/empleados.vue"),
    meta: {
			title: 'i18n:',
        resource: "Camaronera",
        action: "ver-camaronera-mantenimiento-empleado",
        pageTitle: "Empleados",
        breadcrumb: [{
            text: "Camaronera"
        },
        {
            text: "Mantenimiento"
        },
        {
            text: "Empleados",
            active: true
        },

        ]
    }
},

{
    path: "/camaronera/informes/cupo-x-colaborador",
    name: "camaronera-informes-cupo-x-colaborador",
    component: () =>
        import("@/views/pages/profremar/informes/cuposXColaborador.vue"),
    meta: {
			title: 'i18n:',
        resource: "Camaronera",
        action: "ver-camaronera-informes-cupo-x-colaborador",
        pageTitle: "Cupos por colaborador",
        breadcrumb: [{
            text: "Camaronera"
        },
        {
            text: "Informes"
        },
        {
            text: "Cupos por colaborador",
            active: true
        },

        ]
    }
},

{
    path: "/camaronera/informes/estado-cuenta-empleado",
    name: "camaronera-informes-estado-cuenta-empleado",
    component: () =>
        import("@/views/pages/profremar/informes/estadoCuentaColaborador.vue"),
    meta: {
			title: 'i18n:',
        resource: "Camaronera",
        action: "ver-camaronera-informes-estado-cuenta-empleado",
        pageTitle: "Estado de Cuenta por Colaborador",
        breadcrumb: [{
            text: "Camaronera"
        },
        {
            text: "Informes"
        },
        {
            text: "Estado de cuenta por colaborador",
            active: true
        },

        ]
    }
},


{
    path: "/camaronera/informes/facturas-empleado",
    name: "camaronera-informes-facturas-empleado",
    component: () =>
        import("@/views/pages/profremar/informes/facturasColaborador.vue"),
    meta: {
			title: 'i18n:',
        resource: "Camaronera",
        action: "ver-camaronera-informes-facturas-empleado",
        pageTitle: "Facturas por Colaborador",
        breadcrumb: [{
            text: "Camaronera"
        },
        {
            text: "Informes"
        },
        {
            text: "Facturas por colaborador",
            active: true
        },

        ]
    }
},


{
    path: "/camaronera/transacciones/gestion-cobranza",
    name: "camaronera-transacciones-gestion-cobranza",
    component: () =>
        import("@/views/pages/profremar/transacciones/gestionCobranza.vue"),
    meta: {
			title: 'i18n:',
        resource: "Camaronera",
        action: "ver-camaronera-transacciones-gestion-cobranza",
        pageTitle: "Gestión de Cobranzas",
        breadcrumb: [{
            text: "Camaronera"
        },
        {
            text: "Transacciones"
        },
        {
            text: "Gestión de cobranzas",
            active: true
        },

        ]
    }
},

{
    path: "/camaronera/transacciones/abonos",
    name: "camaronera-transacciones-abonos",
    component: () =>
        import("@/views/pages/profremar/transacciones/abonos.vue"),
    meta: {
			title: 'i18n:',
        resource: "Camaronera",
        action: "ver-camaronera-transacciones-abonos",
        pageTitle: "Generar abonos",
        breadcrumb: [{
            text: "Camaronera"
        },
        {
            text: "Transacciones"
        },
        {
            text: "Generar abonos",
            active: true
        },

        ]
    }
},

]


//ver-profremar-transacciones-gestion-cobranza
